<script>
	import BlockParty from './../../embeds/BlockParty.svelte';
  import { csv } from 'd3-fetch';
  export let city; // just name of the place
  export let isCity;
  import BlockPartyText from './BlockPartyText.svelte';
  import { __ } from '../../../utils/i18n'

  $: info = lookup(city)

  const url = new URL('./../../../../assets/data/block-party.csv', import.meta.url);
  // const url = window.DATA_URLS.block-party;

  async function lookup(c) {
    if (c != undefined){
        const data = await csv(url);
        let d = data.find((item) => item.city.trimEnd() == c);

        info = d;
    }
  }

  let showAll = false;
  function onToggle() {
    showAll = !showAll;
  }
</script>
  
<div class="icard block slim" class:show-more={showAll}>
  <div class="header slim">
    <h3>🎉 {__("How to throw a block party")}</h3>
    <button on:click={onToggle}>{showAll ? '-' : '+'}</button>
  </div>

  <div>
    {#await info}
      <p />
    {:then p}
      <BlockPartyText info={p}/>
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
  </div>
</div>

